import cx from 'classnames'
import { type ComponentProps, type ElementType, createElement, forwardRef } from 'react'

export { cx }

type ClassInput = Parameters<typeof cx>

export const component = <ComponentType extends ElementType>(
  Component: ComponentType,
  defaultProps: Partial<ComponentProps<ComponentType>> = {},
) => <StyleProps extends object = {}, RequiredForwardedProps extends object = {}>(
  className: ClassInput[0] | ClassInput | ((props: StyleProps) => ClassInput),
) => forwardRef((props: ComponentProps<ComponentType> & StyleProps & RequiredForwardedProps, ref) => {
  const styledClassRaw = typeof className === 'function' ? className(props) : className
  const styledClass = Array.isArray(styledClassRaw) ? styledClassRaw : [styledClassRaw]
  return createElement(Component, { ...defaultProps, ...props, className: cx(...styledClass, props.className), ref }) 
})

export const div = component('div')
export const paragraph = component('p')

export const span = component('span')

export const anchor = component('a')

export const button = component('button')

export const input = component('input')

export const label = component('label')

export const form = component('form')

export const img = component('img')

export const section = component('section')
export const article = component('article')  

export const ul = component('ul')
export const ol = component('ol')
export const li = component('li')
export const h1 = component('h1')
export const h2 = component('h2')
export const h3 = component('h3')
export const h4 = component('h4')
export const h5 = component('h5')
